import galleryImages01 from "../../assets/images/gallery-01.jpg";
import galleryImages02 from "../../assets/images/gallery-02.jpg";
import galleryImages03 from "../../assets/images/gallery-03.jpg";
import galleryImages04 from "../../assets/images/gallery-04.jpg";
import galleryImages05 from "../../assets/images/gallery-05.jpg";
import galleryImages06 from "../../assets/images/gallery-06.jpg";
import galleryImages07 from "../../assets/images/gallery-07.jpg";
const galleryImages = [
  galleryImages01,
  galleryImages02,
  galleryImages03,
  galleryImages04,
  galleryImages05,
  galleryImages06,
  galleryImages07,
];
export default galleryImages;
